import React, { useState, useEffect } from "react";

export default function CustomPlaceHolder({ labels }) {
  return (
    <div tabIndex="0" aria-label={labels.main_label + labels.label+" "+labels.Start_typing }>
      <span>{labels.main_label} </span>
      <span>{labels.label}</span>
    </div>
  );
}
